import React, { useEffect, useState } from "react";
import EmptyVeille from "./EmptyVeille";
import ScreenSaver from "./ScreenSaver";
import InfoChannel from "./InfoChannel";
import SlideShow from "./SlideShow";
import { useVeille } from "../../redux/Hooks";
import ucFirst from "../../utils/ucFirst";
import CallToAction from "./CallToAction";
import FaceDetector from "./FaceDetector";

const componentsList = {
  ScreenSaver,
  InfoChannel,
  SlideShow,
};

const keysToExclude = ["activated", "timer", "personDetection"];

interface VeilleManagerProps {
  timerRefresh: () => void;
}

const VeilleManager = ({ timerRefresh }: VeilleManagerProps) => {
  const veille = useVeille();
  const [allowedPages, setAllowedPages] = useState<Array<string>>([]);
  const [currentComponent, setCurrentComponent] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (veille && veille.activated) {
      // Mute if wanted
      // veille.muted &&
      //   window?.electronAPI?.muteVeille &&
      //   window.electronAPI.muteVeille(true);
      var temp: Array<string> = [];
      const keys = Object.keys(veille);
      keys.forEach((key) => {
        if (!keysToExclude.includes(key)) {
          const activated = veille[key]?.activated || false;
          activated && temp.push(ucFirst(key));
        }
      });

      setAllowedPages(temp);
      setCurrentComponent(temp[0]);
    } else {
      setAllowedPages([]);
    }

    return () => {
      // veille?.muted &&
      //   window?.electronAPI?.muteVeille &&
      //   window.electronAPI.muteVeille(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [veille]);

  const switchComponent = () => {
    if (allowedPages.length > 1 && currentComponent) {
      const currentIndex = allowedPages.indexOf(currentComponent);
      currentIndex === allowedPages.length - 1
        ? setCurrentComponent(allowedPages[0])
        : setCurrentComponent(allowedPages[currentIndex + 1]);
    } else if (allowedPages.length === 1 && currentComponent) {
      setCurrentComponent(undefined);
      setCurrentComponent(currentComponent);
    }
  };

  return (
    <div onClick={timerRefresh} className="h-screen w-screen cursor-pointer">
      {allowedPages.length === 0 ? (
        <EmptyVeille />
      ) : currentComponent ? (
        allowedPages.map((name, index) => {
          //@ts-ignore
          const Comp = componentsList[name];

          return (
            currentComponent === name && (
              <Comp
                key={index}
                switchComponent={switchComponent}
                loop={allowedPages.length === 1}
              />
            )
          );
        })
      ) : (
        <div> Waiting </div>
      )}
      <CallToAction />
      {veille?.personDetection?.activated && (
        <FaceDetector
          onFaceDetected={timerRefresh}
          webcamId={veille?.personDetection?.webcamId}
        />
      )}
    </div>
  );
};

export default VeilleManager;
